module.exports = __webpack_public_path__ + "static/media/logodp.a3da1030.png";